import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { localizeCurrencyToWholeNumber } from "src/utils";
import { TradeIn } from "Types/TradeIn";
import "./RemainingBalance.scss";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { isUS } from "src/utils/account";
import useSelector from "src/utils/useSelector";
import { getCountry } from "src/store/selectors/account";

interface RemainingBalanceProps {
    balance?: number;
    onChange: (data: Partial<TradeIn>) => void;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const RemainingBalance = (props: RemainingBalanceProps) => {
    const { t } = useTranslation();
    const [balanceDisplay, setBalanceDisplay] = useState(
        props.balance ? localizeCurrencyToWholeNumber(props.balance) : ""
    );
    const country = useSelector(getCountry);

    const handleOnChange = (event: any) => {
        setBalanceDisplay(event.target.value);
    };

    const handleBlur = (event: any) => {
        const value = event.target.value.replace(",", "").slice(isUS(country) ? 1 : 3);
        props.onChange({
            balance: parseInt(value, 10),
        });
    };

    const handleOnFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        props.onFocus && props.onFocus(event);
    };

    return (
        <div className="RemainingBalance__container">
            {t("TradePending.RemainingBalance.question")}
            <MaskedInput
                className="RemainingBalance__input"
                mask={createNumberMask({
                    prefix: `${isUS(country) ? "$" : "CA$"}`,
                    integerLimit: 5,
                })}
                guide={false}
                onChange={handleOnChange}
                onFocus={handleOnFocus}
                onBlur={handleBlur}
                placeholder={`${isUS(country) ? "$" : "CA$"}`}
                value={balanceDisplay}
                type="string"
                data-e2e="tradeInRemainingBalanceInput"
            />
        </div>
    );
};

export default RemainingBalance;
